const initialStateSucursal = {
  response: [],
  responseError: false,
  sucursalSelected: null,
  responseSave: {},
  responseSaveError: false,
};
export default initialStateSucursal;